var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfileUnspedcified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "primary",
    fill: "currentColor",
    stroke: "none",
    d: " M 2.5 15.5 Q 2.5 20.7 6.15 24.3 9.8 28 15 28 L 15 3 Q 9.8 3 6.15 6.65 2.5 10.3 2.5 15.5 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    fill: "currentColor",
    stroke: "none",
    d: " M 23.8 24.3 Q 27.5 20.65 27.5 15.5 27.5 10.3 23.8 6.65 20.15 3 15 3 L 15 28 Q 20.15 28 23.8 24.3 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileUnspedcified);
export default __webpack_public_path__ + "static/media/icon-profile-unspedcified.f0d525ca9f32d26083301d6efeb95fae.svg";
export { ForwardRef as ReactComponent };